export default __webpack_public_path__ + "static/media/evgLogo.1ddf43a3.png";